import { jsx as _jsx } from "react/jsx-runtime";

function SvgFacebookSingle() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.719 22.998C18.977 22.168 23 17.59 23 12.066 23 5.955 18.075 1 12 1S1 5.955 1 12.066C1 17.593 5.028 22.174 10.292 23v-7.86H7.5v-3.165h2.782V9.181c0-.724.383-2.12 1.218-2.893.905-.838 1.976-.998 3-.998 1.425 0 2.385.237 2.385.237v2.675h-1.667c-.768 0-1.5.59-1.5 1.713v2.06h3.06l-.497 3.165H13.72v7.858z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgFacebookSingle;